import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWheel = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "wheel_a__a",
			width: 16,
			height: 16,
			x: -4,
			y: -4,
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 8,
				cy: 8,
				r: 5,
				fill: "none",
				stroke: "#fff",
				strokeDasharray: 1.568,
				strokeWidth: 5
			})
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 8,
			r: 2,
			fill: "currentColor",
			opacity: .4
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 8,
			r: 2.5,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 5,
			mask: "url(#wheel_a__a)",
			opacity: .6
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 8,
			r: 6,
			fill: "none",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 8,
			r: 7.5,
			fill: "none",
			stroke: "currentColor",
			opacity: .5
		})
	]
});
export default SvgWheel;
